import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-refund-allowance-dialog',
  templateUrl: './refundallowancedialog.component.html',
  styleUrls: ['./refundallowancedialog.component.scss'],
})
export class RefundAllowanceDialogComponent {

  public form;
  public member;
  public balance: number;
  public displayBalance: string;
  public reservation: any;
  public statusMode: boolean;

  constructor(
      private formBuilder: UntypedFormBuilder,
      public dialogRef: MatDialogRef<RefundAllowanceDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: RefundAllowanceDialogModel,
  ) {
    this.member = data.member;
    this.reservation = data.member?.teamuserMetadata?.allowanceRefundReservation;
    this.statusMode = !!this.reservation;
    this.balance = this.toCurrencyAmount(data.member.balance);
    this.displayBalance = this.balance.toFixed(2);
    this.form = this.formBuilder.group({
      amount: new UntypedFormControl(this.displayBalance, [
        Validators.required,
        Validators.min(0.01),
        Validators.max(this.balance),
        Validators.pattern(/^\d+(\.\d{0,2})?$/),
      ]),
    });
  }

  async refundClicked(): Promise<void> {
    this.dialogRef.close(this.toCurrencyAmount(this.form.get('amount')?.value));
  }

  onDismiss(): void {
    this.dialogRef.close(null);
  }

  retryClicked(): void {
    this.dialogRef.close('retry');
  }

  canManageReservation(): boolean {
    return ['REQUESTED', 'AWAITING_LIQUIDITY'].includes(this.reservation?.status);
  }

  getStatusLabel(): string {
    switch (this.reservation?.status) {
      case 'FAILED':
        return 'Needs Wallit support';
      case 'PROCESSING':
        return 'Processing';
      default:
        return 'Awaiting funds';
    }
  }

  cancelRequestClicked(): void {
    this.dialogRef.close('cancel');
  }

  private toCurrencyAmount(amount: string | number): number {
    return Math.round(Number(amount) * 100) / 100;
  }

}

export class RefundAllowanceDialogModel {
  constructor(public member: any) {
  }
}
